export const permissionToText: Record<string, string> = {
    SUPER_ADMIN: 'Super Admin',
    ADMIN: 'Admin',
    GROUP_LEADER: 'Group Leader',
    TEAM_LEADER: 'Team Leader',
    VIEW_ONLY: 'View Only',
    CUSTOM: 'Custom',
    DISPATCHER: 'Dispatcher',
    CREATE_CUSTOMER_WEB_APP_USER: 'Create Admin',
    SEND_USER_INVITE: 'Send User Invite to Subscription',
    CHANGE_SUBSCRIPTION_INVITE_CODE: 'Change Subscription Invite Code',
    REMOVE_USER_FROM_SUBSCRIPTION: 'Remove User From Subscription',
    DESTROY_DEVICE: 'Destroy Device',
    MANAGE_CUSTOMER_WEB_APP_USER_PERMISSIONS: 'Manage Admin Permissions',
    RESOLVE_ALERT: 'Resolve alert',
    INTAKE_RISK_ASSESSMENT: 'Intake Risk Assessment'
};

export const ROLE_HIERARCHY: Record<string, number> = {
    POMMASTER: 6,
    SUPER_ADMIN: 5,
    ADMIN: 4,
    GROUP_LEADER: 3,
    TEAM_LEADER: 2,
    VIEW_ONLY: 1,
};

export const customerPermissionFlags = {
    ADMIN: 'ADMIN',
    TEAM_LEADER: 'TEAM_LEADER',
    CUSTOM: 'CUSTOM',
    DISPATCHER: 'DISPATCHER',
    SUPER_ADMIN: 'SUPER_ADMIN',
    VIEW_ONLY: 'VIEW_ONLY',
    GROUP_LEADER: 'GROUP_LEADER',
    // Additive capability: grants the Risk Assessment tab. As a user's sole flag
    // it defines a pure intake specialist (stripped IRA-only experience); layered
    // on a base role it just adds the tab. Mirror of the pom-2-api constant.
    INTAKE_RISK_ASSESSMENT: 'INTAKE_RISK_ASSESSMENT',
};

// Base roles a user can hold, EXCLUDING the intake capability. Used to tell a
// pure intake specialist (only INTAKE_RISK_ASSESSMENT) apart from someone who
// has intake layered on a real role.
export const BASE_ROLE_FLAGS = [
    customerPermissionFlags.SUPER_ADMIN,
    customerPermissionFlags.ADMIN,
    customerPermissionFlags.VIEW_ONLY,
    customerPermissionFlags.GROUP_LEADER,
    customerPermissionFlags.TEAM_LEADER,
    customerPermissionFlags.DISPATCHER,
    customerPermissionFlags.CUSTOM,
];

export const customPermissions = {
    CREATE_CUSTOMER_WEB_APP_USER: 'CREATE_CUSTOMER_WEB_APP_USER',
    SEND_USER_INVITE: 'SEND_USER_INVITE',
    CHANGE_SUBSCRIPTION_INVITE_CODE: 'CHANGE_SUBSCRIPTION_INVITE_CODE',
    REMOVE_USER_FROM_SUBSCRIPTION: 'REMOVE_USER_FROM_SUBSCRIPTION',
    DESTROY_DEVICE: 'DESTROY_DEVICE',
    MANAGE_CUSTOMER_WEB_APP_USER_PERMISSIONS: 'MANAGE_CUSTOMER_WEB_APP_USER_PERMISSIONS',
    RESOLVE_ALERT: 'RESOLVE_ALERT',
};

export const listCustomPermissions = () => Object.keys(customPermissions).map((k) => k);
